export default "__VITE_ASSET__DaF3fWTY__"